<enelx-navbar productName="DR OPS Stream UI" [url]="navbarUrl" position="left" [maxMenuElements]="0">
  <div slot="content">
    @if (isRouteLoading()) {
    <div class="global-loader">
      <dsy-loader type="spinner" size="small" animation-speed="slow"></dsy-loader>
    </div>
    }
    <router-outlet />
    <ngx-global-contact-footer [disableFeedback]="false"></ngx-global-contact-footer>
  </div>
</enelx-navbar>
